/* global hbspt */
import React from 'react'

export default class Hbs extends React.Component {
  componentDidMount () {
    hbspt.forms.create({
      css: '',
      portalId: '466960',
      formId: '4de19a0b-4daf-41fb-ab69-b37450220fca',
      target: '.contact-us-form'
    })
  }

  render () {
    return (
      <div className="contact-us-form" />
    )
  }
}



// WEBPACK FOOTER //
// ./components/Hbs.js